import { render, staticRenderFns } from "./ExtendedFullPage.vue?vue&type=template&id=5040f280&scoped=true&"
import script from "./ExtendedFullPage.vue?vue&type=script&lang=js&"
export * from "./ExtendedFullPage.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedFullPage.vue?vue&type=style&index=0&id=5040f280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040f280",
  null
  
)

export default component.exports